export const navigateHome = () => {
  window.location.href = '/'
}

export const navigateBack = () => {
  window.history.back()
}